import { useWSModal } from "@wingspanhq/fe-component-library";
import { PredefinedLineItemsModal } from "./PredefinedLineItemsModal";

export function usePredefinedLineItemsModal() {
  return useWSModal(PredefinedLineItemsModal, {
    title: "Add pre-defined line item descriptions",
    size: "S"
  });
}
